<section>
  <input (keyup.backspace)="searchEvent.emit()" (keyup.enter)="searchEvent.emit()"
    class=" border-0 border-none bg-blue-100 text-gray-800 p-2.5 leading-none w-64 rounded-lg rounded-r-none focus:outline-none relative " type="text" [id]="id"
    type="text" [formControl]="control" [placeholder]="placeholder" />
  <button
    class="text-center border-0 border-none bg-primary hover:bg-primary text-white cursor-pointer px-2 py-1 rounded-lg rounded-l-none focus:outline-none absolute"
    type="submit" (click)="searchEvent.emit()">
    <fa-icon [icon]="faIcon" class="text-xl"></fa-icon>
  </button>
</section>